module.exports = "/_next/static/images/ce1824a784d5d2f6f0c1bf729df6a1b8-notification.svg.webp";